<template>
  <div :class="arrowClass" @click.stop="$emit('arrowClick')">
    <img src="@/assets/img/arrow-back.png">
    {{text}}
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    value: String
  },
  data() {
    return {
      defaultValue: {
        back: this.$t("base.back"),
        next: this.$t("base.next")
      }
    };
  },
  computed: {
    text() {
      return this.value ? this.value : this.defaultValue[this.type];
    },
    arrowClass() {
      return `arrow-${this.type}`;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.arrow-back,
.arrow-next {
  position: relative;
  display: inline-block;
  padding: 0.5rem 1rem;
  color: $primary;
  font-weight: 900;

  img {
    position: absolute;
    @include scaleimg(0.5);
  }
}

.arrow-back img {
  left: 0;
}

.arrow-next img {
  right: 0;
}
</style>
